import { render, staticRenderFns } from "./SupplierInventoryList.vue?vue&type=template&id=f7383e0a&scoped=true"
import script from "./SupplierInventoryList.vue?vue&type=script&lang=js"
export * from "./SupplierInventoryList.vue?vue&type=script&lang=js"
import style0 from "./SupplierInventoryList.vue?vue&type=style&index=0&id=f7383e0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7383e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7383e0a')) {
      api.createRecord('f7383e0a', component.options)
    } else {
      api.reload('f7383e0a', component.options)
    }
    module.hot.accept("./SupplierInventoryList.vue?vue&type=template&id=f7383e0a&scoped=true", function () {
      api.rerender('f7383e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/SupplierInventoryList.vue"
export default component.exports